import React, { useCallback, useEffect, useState } from 'react';
import { AvatarPicker } from '@base/features/avatar/avatarPicker';
import { ResponseCode, StorageKeys } from '@base/utils/constants';
import { container } from 'tsyringe';
import UserService from '@base/features/user/model/userService';
import { ILocalStorage } from '../../storage/interfaces';
import { IAuthService } from '@base/features/auth/model/interfaces';
import MainButton from '@ui-kit/components/mainButton';
import { Loader } from '@ui-kit/components/loader';
import { t } from '../../../utils/helpers';
import { IModalProvider } from '@base/features/modal/model/interfaces';
import AuthWrapImage from './authWrapImage';

const ChangeSocialUsername = (props: { title: string }) => {
  const localStorage: ILocalStorage = container.resolve('localStorage');
  const userService: UserService = container.resolve('userService');
  const authService: IAuthService = container.resolve('authService');
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const userAutData = localStorage.get(StorageKeys.TEMP_DATA);
  const usr = (userAutData && userAutData.res.usr) || '';
  const session = (userAutData && userAutData.res.session) || '';
  const userId = userAutData && userAutData.res.user_id;
  const socialAvatar = (userAutData && userAutData.user.picture.data.url) || null;
  const socialUsername = (userAutData && userAutData.user.name) || '';
  const [isProcessing, setIsProcessing] = useState(false);
  const [name, setName] = useState(socialUsername);
  const [recommender, setRecommender] = useState('');
  const [formValid, setFormValid] = useState(false);
  const [placeholderUsername, setPlaceholderUsername] = useState('username');

  function handleLoginChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement | null;
    target && setName(target.value);
  }

  function handleRecommenderChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement | null;
    target && setRecommender(target.value);
  }

  const fetchUsername = useCallback(
    async (name: string) => {
      const response = await authService.checkUsernameAvailability(name);
      if (!response) {
        setPlaceholderUsername('cannot_connect_to_server');
        return;
      }
      //плохое имя
      if (response.code === ResponseCode.NAME_IS_NOT_AVAILABLE) {
        setPlaceholderUsername(`Name '${name}' is not available`);
      }
      //имя уже используется
      else if (response.code === ResponseCode.NAME_IS_ALREADY_USED) {
        setPlaceholderUsername(`Name '${name}' is not available`);
      } else if (response.code === ResponseCode.SUCCESS) {
        setPlaceholderUsername('name_available');
        //Доступно
        setFormValid(true);
      }
    },
    [authService]
  );

  const checkUsernameValid = useCallback(
    (name) => {
      setFormValid(false);
      if (!name) {
        setPlaceholderUsername('username');
      } else {
        fetchUsername(name);
      }
    },
    [fetchUsername]
  );

  async function doEntry(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    setIsProcessing(true);
    try {
      const response = await userService.setLogin(usr, session, name);
      setIsProcessing(false);
      if (response.code === ResponseCode.SUCCESS) {
        userAutData.res.usr = name;
        authService.doEntryDefault(userAutData.res);
        localStorage.delete(StorageKeys.TEMP_DATA);
      } else if (response.code === ResponseCode.FAIL_LOGIN_CHANGE) {
        modalProvider.show({
          title: t('error'),
          body: t('only_one_login_change_allowed'),
          buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
        });
      } else {
        modalProvider.show({
          title: t('error'),
          body: t('login_connection_error'),
          buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
        });
      }
    } catch (e) {
      setIsProcessing(false);
      modalProvider.show({
        title: t('error'),
        body: t('login_connection_error'),
        buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
      });
    }
  }

  const loaderJSX = isProcessing && <Loader className="loader-container--black" />;

  useEffect(() => {
    checkUsernameValid(name);
  }, [name, checkUsernameValid]);

  return (
    <div className="auth">
      {loaderJSX}
      <AuthWrapImage />
      <div className="register-page">
        <div className="register-wrap">
          <div className="register-title">
            <div className="register-title-item--left" />
            <div className="register-title-item">
              <h2>{t(props.title)}</h2>
            </div>
            <div className="register-title-item--right" />
          </div>
          <div className="register-form">
            <div className="auth-form">
              <div className="auth-form-item">
                <input
                  className={
                    formValid ? 'auth-form-item__text auth-form-item__text--valid' : 'auth-form-item__text'
                  }
                  placeholder={t(`${placeholderUsername}`)}
                  id="inputname-login"
                  type="text"
                  maxLength={20}
                  value={name}
                  onChange={handleLoginChange}
                />
              </div>

              <div className="auth-form-item">
                <input
                  className="auth-form-item__text auth-form-item__text--dont-need-valid"
                  placeholder={t('recommender_optional')}
                  id="facebook-recommender"
                  type="text"
                  value={recommender}
                  onChange={handleRecommenderChange}
                />
              </div>

              <div className="auth-form-item auth-form-item--avatar">
                <AvatarPicker usr={usr} session={session} socialAvatar={socialAvatar} userId={userId} />
              </div>

              <div className="register__btn-wrap">
                <MainButton
                  className="register__btn register__btn-sign-up"
                  disabled={!formValid}
                  onClick={doEntry}
                >
                  {t('signup')}
                </MainButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeSocialUsername;
